import React from 'react';
import TextField from '@mui/material/TextField';
import { GREEN_COLOR } from 'src/utils/pnd/PndConstants';

const MuiTextField = ({
    input,
    label, // Label for the TextField
    placeholder,
    type,
    meta: { touched, error, warning },
    width, // New width prop
}) => (
    <div className="form__form-group" style={{ width: width || '100%' }}>
        <TextField
            {...input}
            type={type} // Make sure to pass the correct input type
            sx={{
                fontSize: 18,
                fontFamily: 'ProductSansRegular',
                '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': {
                        borderColor: '#4caf50', // Hover color
                    },
                    '&.Mui-focused fieldset': {
                        borderColor: GREEN_COLOR, // Focused color
                    },
                },
                '& .MuiInputLabel-root.Mui-focused': {
                    color: GREEN_COLOR, // Focused label color
                },
            }}
            label={label} // Ensure label is passed
            error={touched && Boolean(error)}
            helperText={touched && (error || warning)}
            variant="outlined"
            style={{ width: width || '100%' }} // Apply width prop dynamically
        />
    </div>
);

export default MuiTextField;
